import React from 'react';
import {connect} from "react-redux";
import {State} from "../reducers";
import {fetchProject} from '../middleware/projectsActions';
import {addProduct, importFile} from '../middleware/productActions';
import ProductsList from "../components/ProductsList";
import {withRouter} from "react-router";
import {GenericThunkDispatch} from "../types/Types";
import {updateProducts, updateProductsFilter} from "../actions/products";
import {FETCH_PRODUCTS_BASE} from "../actions/products";

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => ({
  fetchData: (projectId: string) => {
    return dispatch<Promise<void | {}>>(fetchProject(projectId))
  },
  addProduct: (projectId: string, name: string) => {
    return dispatch<Promise<void | {}>>(addProduct(projectId, name))
  },
  updateProductsFilter:  (e: any) => {
    if (e.target) {
      return dispatch(updateProductsFilter(e.target.value || ""))
    }
  },
  importFile: (projectId: string, file: File) => {
    return dispatch<Promise<void | {}>>(importFile(projectId, file))
  },
  resetProducts: () => {
    return dispatch(updateProducts([]));
  }
});

const isFetchingProducts = (state: State) => {
  return !state.loading[FETCH_PRODUCTS_BASE] || state.loading[FETCH_PRODUCTS_BASE].showLoader
};

const mapStateToProps = (state: State) => ({
    items: state.products.items,
    projectId: state.products.projectId,
    filter: state.products.filter,
    isLoading: isFetchingProducts(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductsList));
